<template>
  <div>

    <b-card-actions action-collapse title="Commodity">
      <div>
             <div
            class="btn-delete-all text-right"
            >
          <b-button variant="gradient-primary" class="btn-icon btn-delete-all mr-1"  @click="saveCommodity()">
            <feather-icon icon="SaveIcon" />
          </b-button>

          <b-button variant="gradient-primary" class="btn-icon mr-1" @click="downloadComXLSX">
            Download
            <feather-icon icon="DownloadIcon" />
          </b-button>
          <vue-xlsx-table @on-select-file="uploadComXLSX" class="btn-icon-upload">
            Upload
            <feather-icon icon="UploadIcon" />
          </vue-xlsx-table>

        </div>
        <div>
          <b-row
            class="mt-1"
            v-for="(item, i) in commodityTab"
            :id="item.id"
            :key="item.id"
          >
            <b-col b-col cols="12" lg="10" md="10" sm="12">
              <b-form-group label="Commodity" label-for="commodity">
                   <b-form-input
                  placeholder="Commodity"
                  v-model="item.title"
                  required
                  id="cargoTemperature"
                />
              </b-form-group>
            </b-col>

            <b-col lg="1" md="1" cols="12" class="mb-50">
              <b-button
                v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                variant="outline-success"
                class="mt-0 mt-md-2"
                @click="repeateAgainCommodity(i)"
              >
                <feather-icon icon="PlusIcon" />
              </b-button>
            </b-col>

            <b-col v-if="i > 0" lg="1" md="1">
              <b-button
                v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                variant="outline-danger"
                class="mt-0 mt-md-2 ml-1"
                @click="removeCommodity(i)"
              >
                <feather-icon icon="XIcon" />
              </b-button>
            </b-col>

            <hr />
          </b-row>


        
        </div>
      </div>
    </b-card-actions>

   <b-card-actions action-collapse title=" Uns">
      <div>
            <div
            class="btn-delete-all text-right"
            >
          <b-button variant="gradient-primary" class="btn-icon btn-delete-all mr-1"  @click="saveUn()">
            <feather-icon icon="SaveIcon" />
          </b-button>

          <b-button variant="gradient-primary" class="btn-icon mr-1" @click="downloadUnXLSX">
            Download
            <feather-icon icon="DownloadIcon" />
          </b-button>
          <vue-xlsx-table @on-select-file="uploadUnXLSX" class="btn-icon-upload">
            Upload
            <feather-icon icon="UploadIcon" />
          </vue-xlsx-table>
        </div>
        <div>
             <b-row
            class="mt-1"
            v-for="(item, i) in unTab"
            :id="item.id"
            :key="item.id"
          >
            <b-col b-col cols="12" lg="10" md="10" sm="12">
              <b-form-group label="UN" label-for="un">
                   <b-form-input
                  placeholder="un"
                  v-model="item.title"
                  required
                  id="un"
                />
              </b-form-group>
            </b-col>

            <b-col lg="1" md="1" cols="12" class="mb-50">
              <b-button
                v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                variant="outline-success"
                class="mt-0 mt-md-2"
                @click="repeateAgainUn(i)"
              >
                <feather-icon icon="PlusIcon" />
              </b-button>
            </b-col>

            <b-col v-if="i > 0" lg="1" md="1">
              <b-button
                v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                variant="outline-danger"
                class="mt-0 mt-md-2 ml-1"
                @click="removeUn(i)"
              >
                <feather-icon icon="XIcon" />
              </b-button>
            </b-col>

            <hr />
          </b-row>
        </div>
      </div>
    </b-card-actions>
       <b-card-actions action-collapse title=" Classe">
      <div>
            <div
            class="btn-delete-all text-right"
            >
          <b-button variant="gradient-primary" class="btn-icon btn-delete-all mr-1"  @click="saveClass()">
            <feather-icon icon="SaveIcon" />
          </b-button>

          <b-button variant="gradient-primary" class="btn-icon mr-1" @click="downloadClasseXLSX">
            Download
            <feather-icon icon="DownloadIcon" />
          </b-button>
          <vue-xlsx-table @on-select-file="uploadClasseXLSX" class="btn-icon-upload">
            Upload
            <feather-icon icon="UploadIcon" />
          </vue-xlsx-table>

        </div>
        <div>
         <b-row
            class="mt-1"
            v-for="(item, i) in classeTab"
            :id="item.id"
            :key="item.id"
          >
            <b-col b-col cols="12" lg="10" md="10" sm="12">
              <b-form-group label="Classe" label-for="classe">
                    <b-form-input
                  placeholder="Classe"
                  v-model="item.title"
                  required
                  id="Classe"
                />
              </b-form-group>
            </b-col>

            <b-col lg="1" md="1" cols="12" class="mb-50">
              <b-button
                v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                variant="outline-success"
                class="mt-0 mt-md-2"
                @click="repeateAgainClasse(i)"
              >
                <feather-icon icon="PlusIcon" />
              </b-button>
            </b-col>

            <b-col v-if="i > 0" lg="1" md="1">
              <b-button
                v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                variant="outline-danger"
                class="mt-0 mt-md-2 ml-1"
                @click="removeClasse(i)"
              >
                <feather-icon icon="XIcon" />
              </b-button>
            </b-col>
            <hr />
          </b-row>
     
        </div>
      </div>
    </b-card-actions>
  </div>
</template>

<script>
import BCardActions from "@core/components/b-card-actions/BCardActions.vue";
import {
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BButton,
  BFormSelect,
} from "bootstrap-vue";
import { heightTransition } from "@core/mixins/ui/transition";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import axios from "@axios";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import * as XLSX from 'xlsx';

export default {
  components: {
    ToastificationContent,
    BForm,
    BRow,
    BCol,
    BButton,
    BFormGroup,
    BFormInput,
    BCardActions,
    BFormSelect,
    vSelect,
    XLSX
  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  data() {
    return {
      json_data: [],
      json_fields: {
        society: "society",
        Nom: "firstName",
        Prenom: "lastName",
        Email: "email",
        Cite: "city",
        numero: "telNumbers",
        "Matricule Fiscale": "registrationNumber",
      },
      // form:{
      //     cy:0,
      //     sd:0,
      // },
      commodityTab: [
        {
          id: 1,
          title: null,
          _id:""
        },
      ],
      classeTab: [
        {
          id: 1,
          title: "",
           _id:""

        },
      ],
      unTab: [
        {
          id: 1,
          title: "",
           _id:""
        },
      ],
      countriesFromAgent: null,
      countriesToAgent: null,
      nextTodoId: 2,
      // Portoptions: [
      //   { value: null, text: "Please select an option" },
      // ],
      commodityItems:{},
      routesToSend:[]
    };
  },
  mounted() {
    //this.initTrHeight()
  },
  created() {
    window.addEventListener("resize", this.initTrHeight);
    this.getDataManagement()
  },
  destroyed() {
    window.removeEventListener("resize", this.initTrHeight);
  },
  methods: {
    async getDataManagement(){
      this.commodityTab=[]
      this.classeTab=[]
      this.unTab=[]
     
        // commodity class un
         axios
        .get(
          "https://mtl-feeder-nodejs.onrender.com/api/commodities"
        )
        .then((response) => {
          response.data.data.forEach((element,index) => {
            this.commodityTab.push({
              id: index,
              title: element.title,
              _id:element._id
            })
          });
        })
        .catch((error) => {
          this.errorMessage = error.message;
        });

       axios
        .get(
          "https://mtl-feeder-nodejs.onrender.com/api/classes"
        )
        .then((response) => {
          response.data.data.forEach((element,index) => {
            this.classeTab.push({
              id: index,
              title: element.title,
              _id:element._id
            })
          });
        })
        .catch((error) => {
          this.errorMessage = error.message;
        });

         axios
        .get(
          "https://mtl-feeder-nodejs.onrender.com/api/uns"
        )
        .then((response) => {
          response.data.data.forEach((element,index) => {
            this.unTab.push({
              id: index,
              title: element.title,
              _id:element._id
            })
          });
        })
        .catch((error) => {
          this.errorMessage = error.message;
        });


    },
    saveCommodity(){
      const filteredData = this.commodityTab.filter(obj => obj.title !== '');
          axios
        .post(
          "https://mtl-feeder-nodejs.onrender.com/api/commodities", filteredData
        )
        .then((response) => {
           this.$toast({
            component: ToastificationContent,
            props: {
              title: "commodity updated",
              icon: "EditIcon",
              variant: "success",
            },
          });
        })
        .catch((error) => {
          this.errorMessage = error.message;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Error during update",
              icon: "EditIcon",
              variant: "danger",
            },
          });
        });
    },
    saveClass(){
      const filteredData = this.classeTab.filter(obj => obj.title !== '');
          axios
        .post(
          "https://mtl-feeder-nodejs.onrender.com/api/classes", filteredData
        )
        .then((response) => {
           this.$toast({
            component: ToastificationContent,
            props: {
              title: "class updated",
              icon: "EditIcon",
              variant: "success",
            },
          });
        })
        .catch((error) => {
          this.errorMessage = error.message;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Error during update",
              icon: "EditIcon",
              variant: "danger",
            },
          });
        });
    },
    saveUn(){
      const filteredData = this.unTab.filter(obj => obj.title !== '');
          axios
        .post(
          "https://mtl-feeder-nodejs.onrender.com/api/uns", filteredData
        )
        .then((response) => {
           this.$toast({
            component: ToastificationContent,
            props: {
              title: "un updated",
              icon: "EditIcon",
              variant: "success",
            },
          });
        })
        .catch((error) => {
          this.errorMessage = error.message;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Error during update",
              icon: "EditIcon",
              variant: "danger",
            },
          });
        });
    },

    repeateAgainCommodity() {
      this.commodityTab.push({
        id: this.commodityTab.length,
        title: "",
      });
    },
    repeateAgainClasse() {
      this.classeTab.push({
        id: this.classeTab.length,
        title: "",
      });
    },
    repeateAgainUn() {
      this.unTab.push({
        id: this.classeTab.length,
        title: "",
      });
    },

    removeCommodity(i) {
      this.commodityTab.splice(i, 1);
    },
    removeClasse(i) {
      this.classeTab.splice(i, 1);
    },
    removeUn(i) {
      this.unTab.splice(i, 1);
    },
    downloadComXLSX() {
      const data = [];
      this.commodityTab.forEach((com) => {
        data.push({
          "Commodity" : com.title,
        })
      })
      const worksheet = XLSX.utils.json_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Commodities');
      XLSX.writeFile(workbook, 'Commodity.xlsx');
    },
    downloadUnXLSX() {
      const data = [];
      this.unTab.forEach((un) => {
        data.push({
          "UN" : un.title,
        })
      })
      const worksheet = XLSX.utils.json_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Un');
      XLSX.writeFile(workbook, 'UN.xlsx');
    },
    downloadClasseXLSX() {
      const data = [];
      this.classeTab.forEach((classe) => {
        data.push({
          "Classe" : classe.title,
        })
      })
      const worksheet = XLSX.utils.json_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Classes');
      XLSX.writeFile(workbook, 'Classe.xlsx');
    },

    uploadComXLSX(convertedData) {
      const data = [];
      let lastId = this.commodityTab[this.commodityTab.length - 1].id;
      convertedData.body.forEach((element) => {
        lastId++ 
        data.push({
          id : lastId,
          title : element["Commodity"],
        })
      })
      this.commodityTab = this.commodityTab.concat(data)
    },
    uploadUnXLSX(convertedData) {
      const data = [];
      let lastId = this.unTab[this.unTab.length - 1].id;
      convertedData.body.forEach((element) => {
        lastId++ 
        data.push({
          id : lastId,
          title : element["UN"],
        })
      })
      this.unTab = this.unTab.concat(data)
    },
    uploadClasseXLSX(convertedData) {
      const data = [];
      let lastId = this.classeTab[this.classeTab.length - 1].id;
      convertedData.body.forEach((element) => {
        lastId++ 
        data.push({
          id : lastId,
          title : element["Classe"],
        })
      })
      this.classeTab = this.classeTab.concat(data)
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
.repeater-form {
  overflow: hidden;
  transition: 0.35s height;
}
.btn-add {
  margin-top: 20px;
}
.btn-icon-upload button{
  background-image: linear-gradient(47deg, #010022, #030055)!important;
  padding: 0.715rem 0.736rem;
  text-align: center;
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 0.358rem
}
</style>